/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/function-component-definition */
import { useState, useEffect } from 'react';
import "./index.css"
import { useTranslation } from 'react-i18next';

// Tipo para los enlaces del breadcrumb
type BreadcrumbLink = {
  label: string;
  url: string;
};

// Props para el componente Breadcrumb
interface BreadcrumbProps {
  links: BreadcrumbLink[];
  showCookieMessage: boolean;
}

const BreadcrumbCookies: React.FC<BreadcrumbProps> = ({ links, showCookieMessage }) => {
  const [cookieMessageSeen, setCookieMessageSeen] = useState<boolean>(false);
  const { t } = useTranslation('global');

  useEffect(() => {
    // Verifica si el mensaje sobre cookies ya ha sido visto
    const seen = localStorage.getItem('cookieMessageSeen') === 'true';
    setCookieMessageSeen(seen);
  }, []);

  const handleCookieMessageDismiss = () => {
    setCookieMessageSeen(true);
    localStorage.setItem('cookieMessageSeen', 'true');
  };

  return (
    <nav>
      <ol style={{ display: "none" }}>
        {links.map((link, index) => (
          <li className='itemRoute' key={index}>
            <a href={link.url}>{link.label}</a>
            {index < links.length - 1 && ' > '}
          </li>
        ))}
      </ol>
      {showCookieMessage && !cookieMessageSeen && (
        <div className='styleBreadcrumbCookies'>
          <p>{t('general.detailsCookies')}
            <button className='btnBreadcrumbCookies' onClick={handleCookieMessageDismiss}>{t('general.acceptCookies')}</button>
          </p>
        </div>
      )}
    </nav>
  );
};

export default BreadcrumbCookies;
